// Columnas del formulario elegidas por el usuario (FormLayoutMenu) y su
// ancho, el mismo para todas (FormColumnRuler). La página pone
// .form-layout-cols y las variables en el contenedor del form; la grilla la
// arma el CSS de FormRenderer. Lo usan dynamic-model-edit y
// DynamicModelCustomFormShell.
export default {
  data() {
    return {
      /** null = automático (anchos por tipo de campo). */
      formColumns: null,
      /** Ancho de cada columna en px; null = repartir todo el ancho. */
      formColumnWidth: null,
      formColumnWidthSaved: null,
      editingFormWidths: false,
    };
  },
  methods: {
    formLayoutClass(enabled) {
      return enabled && this.formColumns ? "form-layout-cols" : "";
    },
    formLayoutStyle(enabled) {
      if (!enabled || !this.formColumns) return null;
      const style = { "--form-cols": this.formColumns };
      // Ancho fijo: las columnas no se encogen y el formulario puede pasar el
      // ancho de la pantalla (se desplaza de costado), si el usuario lo eligió así.
      // La tarjeta crece con la grilla (4rem = sus márgenes internos y los de
      // las secciones); width: max-content no sirve, las col-* en % lo anulan.
      if (this.formColumnWidth) {
        style["--form-grid"] = `repeat(${this.formColumns}, ${this.formColumnWidth}px)`;
        style.minWidth = `max(100%, calc(${this.formColumns * this.formColumnWidth}px + 4rem))`;
      }
      return style;
    },
    onFormLayoutChange(layout) {
      this.formColumns = layout ? layout.columns : null;
      this.formColumnWidth = layout && layout.columnWidth ? layout.columnWidth : null;
      this.formColumnWidthSaved = this.formColumnWidth;
      if (!this.formColumns) this.editingFormWidths = false;
    },
    async onFormWidthsDone(columnWidth) {
      this.editingFormWidths = false;
      if (this.$refs.formLayoutMenu) {
        await this.$refs.formLayoutMenu.saveColumnWidth(columnWidth);
      }
    },
    onFormWidthsCancel() {
      this.formColumnWidth = this.formColumnWidthSaved;
      this.editingFormWidths = false;
    },
  },
};
